export const crossPromoVkMusicFakedoorModalAnalyticsMap = {
    a: 'mnz_upsale_control',
    b: 'fake_upsale_vk_music',
    c: 'fake_vk_music_sale50',
    d: 'fake_vk_music_sale70',
};
